import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import "../css/nav.css";
import {
  FaBars,
  FaTimes,
} from "react-icons/fa";

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const getActive = (path) => {
    if (path === "/") return location.pathname === "/" ? "active" : "";
    return location.pathname.startsWith(path) ? "active" : "";
  };

  const overlayHeroPaths = [
    "/",
    "/walkingandhikingtours",
    "/naturalexperiences",
    "/nationalparks",
    "/see-all",
    "/planyourjourney",
    "/trip-planner",
    "/emergencyNumber",
    "/contact",
    "/map-view",
  ];
  const isHeroOverlay = overlayHeroPaths.some((path) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path)
  );

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={`nav-container ${isHeroOverlay ? "nav-over-hero" : ""}`}>
      <div className="logo-menu-container">
        <div className="logo-container">
          <Link to="/" onClick={closeMenu} aria-label="Kim Tour home">
            <span className="text-logo">KimTour</span>
            <small>Sponsored by Sol Plaatje Municipality</small>
          </Link>
        </div>

        {/* Hamburger */}
        <button
          type="button"
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Menu */}
        <ul className={`main-menu ${menuOpen ? "open" : ""}`}>
          <li className={getActive("/")}>
            <Link to="/" className="nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>

          <li className={getActive("/walkingandhikingtours")}>
            <Link
              to="/walkingandhikingtours"
              className="nav-link"
              onClick={closeMenu}
            >
              Places to Explore
            </Link>
          </li>

          <li className={getActive("/planyourjourney")}>
            <Link
              to="/planyourjourney"
              className="nav-link"
              onClick={closeMenu}
            >
              Plan Your Journey
            </Link>
          </li>

          <li className={getActive("/trip-planner")}>
            <Link
              to="/trip-planner"
              className="nav-link"
              onClick={closeMenu}
            >
              My Trip
            </Link>
          </li>

          <li className={getActive("/map-view")}>
            <Link to="/map-view" className="nav-link" onClick={closeMenu}>
              Map
            </Link>
          </li>

          <li className={getActive("/emergencyNumber")}>
            <Link
              to="/emergencyNumber"
              className="nav-link"
              onClick={closeMenu}
            >
              Emergency Number
            </Link>
          </li>

          <li className={getActive("/contact")}>
            <Link to="/contact" className="nav-link" onClick={closeMenu}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NavBar;
